var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 58.9637,
    height: 59,
    rx: 29.4819,
    fill: "#F7F8FA",
    stroke: "#3D7AB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6338 31.7844L44.8095 18.346C45.0128 18.1028 45.0568 17.7628 44.925 17.4737C44.7919 17.1846 44.507 17 44.1932 17H15.8068C15.493 17 15.208 17.1846 15.075 17.4737C14.9432 17.7628 14.9872 18.1028 15.1905 18.346L26.3662 31.7844C26.493 31.9321 26.5608 32.1244 26.5558 32.3217V46.58C26.552 46.7405 26.6411 46.8882 26.783 46.9582C26.926 47.0295 27.0955 47.0079 27.2172 46.906L33.4441 41.7169V32.3218C33.439 32.1244 33.507 31.9321 33.6338 31.7844Z",
    fill: "#3D7AB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterButton);
export default __webpack_public_path__ + "static/media/filterButton.b9c0466db7d7ff2e05e5350aa53d04a5.svg";
export { ForwardRef as ReactComponent };